import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

import "./FormSideWidgetContainer.scss";

enum FormWidgetPosition {
    Left,
    Right
}

interface FormSideWidgetContainerProps {
    width: string;
    position: FormWidgetPosition;
    leftOffset?: string;
    rightOffset?: string;
    topOffset?: string;
    containerClassName?: string
}

class FormSideWidgetContainer extends BaseReactComponent<FormSideWidgetContainerProps> {
    public render(): JSX.Element {
        const width = this.props.width;
        const containerStyle: React.CSSProperties = {
            width: width
        };

        switch (this.props.position) {
            case FormWidgetPosition.Left:
                const leftOffset = this.props.leftOffset
                    ? `+ ${this.props.leftOffset}`
                    : "";
                containerStyle.left = `calc(-1 * (${width} ${leftOffset}))`;
                break;
            case FormWidgetPosition.Right:
                const rightOffset = this.props.rightOffset
                    ? `+ ${this.props.rightOffset}`
                    : "";
                containerStyle.right = `calc(-1 * (${width} ${rightOffset}))`;
                break;
        }

        if (this.props.topOffset)
            containerStyle.top = this.props.topOffset;

        return (
            <div className="form-widget-container">
                <div className={`${this.props.containerClassName ?? ""}`} style={containerStyle}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export { FormSideWidgetContainer, FormWidgetPosition };
